module.exports = __webpack_public_path__ + "img/tu14.6e5b6503.jpg";